import { render, staticRenderFns } from "./FoodSelects.vue?vue&type=template&id=c9eb1fc8&"
import script from "./FoodSelects.vue?vue&type=script&lang=js&"
export * from "./FoodSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports